import { Permission } from '../../legacy/common/types'
import { type AccessControlConfig } from '../../legacy/components/AccessControl/accessControl.utils'

export const AppContractorPortalSectionAccessControl: AccessControlConfig = {
  // Put all permissions that allow contractor portal access here
  permissions: [Permission.RecipesModify],
}
